module.exports = __webpack_public_path__ + "img/Meloni.054c2b10.svg";